import InfoPoint from '../components/info-point';
import { isMobile } from '../utlis/is-mobile';

export default class Stats {
    constructor(element) {
        this.el = element;
        this.infoPoints = [];
        this.winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        // Select all info-points within the stats element
        const nodes = [].slice.call(this.el.querySelectorAll('[info-point]'));
        this.infoPoints = nodes.map(node => new InfoPoint(node));

        // Initialize event listeners
        this.initEventListeners();

        // Handle window load and setup initial state
        if (document.readyState === 'complete') {
            this.run();
        } else {
            window.addEventListener("load", this.run.bind(this));
        }
    }

    initEventListeners() {
        // Set up click and mouse events for each info-point
        this.infoPoints.forEach((point, i) => {
            point.area.addEventListener('click', this.onClick.bind(this, i));

            if (!isMobile) {
                point.area.addEventListener("mouseenter", point.onEnter);
                point.area.addEventListener('mousemove', point.onMove);
                point.area.addEventListener("mouseleave", point.onLeave);
            }
        });
    }

    onClick(index) {
        this.infoPoints.forEach((point, i) => {
            if (i === index) {
                point.activate();
            } else {
                point.deactivate();
            }
        });
    }

    run() {
        // Activate the second info-point on load
        if (this.infoPoints[1]) {
            this.infoPoints[1].activate();
        }
    }

    disconnect() {
        // Remove event listeners when disconnecting
        this.infoPoints.forEach((point, i) => {
            point.area.removeEventListener('click', this.onClick);

            if (!isMobile) {
                point.area.removeEventListener("mouseenter", point.onEnter);
                point.area.removeEventListener('mousemove', point.onMove);
                point.area.removeEventListener("mouseleave", point.onLeave);
            }
        });

        window.removeEventListener("load", this.run);
    }
}